import { getController } from '@/controllers/request';

export default {
  namespaced: true,
  state: {
    updateIntent: null,
    panelMode: null,
    metadata: null,
    loading: false,
    vacancyId: '',
    stages: null,
    hiddenStages: [],
    candidateTabOnceOpened: false
  },
  mutations: {
    setParam(state, { name, val, param }) {
      if (param) {
        state[name][param] = val;
      } else {
        state[name] = val;
      }
      if (name == 'panelMode') {
        state.metadata = null;
      }
    }
  },
  actions: {
    async getMetadata(
      { state, commit, rootState },
      { intentOrRequest, newCheck = true }
    ) {
      try {
        commit('setParam', { name: 'loading', val: true });

        commit('setParam', { name: 'updateIntent', val: intentOrRequest });

        let response = {};
        if (intentOrRequest?.url) {
          let params = intentOrRequest?.request_dynamic_params?.hasOwnProperty(
            'candidate_id'
          )
            ? {
                candidate_id: rootState.vacancy.currentVacancyCandidate.ID,
                ...intentOrRequest.request_params
              }
            : { ...intentOrRequest.request_params };

          let url = intentOrRequest?.request_dynamic_params?.hasOwnProperty(
            'candidate_id'
          )
            ? intentOrRequest.url
            : rootState.filters.filterAdditionalUrl['vacancy_candidates'] &&
              newCheck
            ? intentOrRequest.url +
              rootState.filters.filterAdditionalUrl['vacancy_candidates']
            : intentOrRequest.url;

          response = await getController({
            url: url,
            params
          });

          let stages = response.data?.content?.data;
          if (stages) {
            commit('setParam', { name: 'stages', val: stages });
          }

          if (
            !intentOrRequest?.request_dynamic_params?.hasOwnProperty(
              'candidate_id'
            )
          ) {
            let ampersandIndex = url.indexOf('&hidden_stage_ids');

            let substring =
              ampersandIndex >= 0 ? url.substring(ampersandIndex) : '';

            substring =
              substring +
              (intentOrRequest.request_params['hidden_stage_ids[]']
                ? `&hidden_stage_ids[]=${intentOrRequest.request_params['hidden_stage_ids[]']}`
                : '');

            commit(
              'filters/setFilterAddUrl',
              { module: 'vacancy_candidates', url: substring },
              {
                root: true
              }
            );
          }
        }
        //в случае изменения выбранного кандидата из вкладки вакансии
        else {
          response = await getController({
            params: intentOrRequest
          });
        }

        if (
          state.panelMode == 'canditatePanel' &&
          response &&
          response.status != 'error'
        ) {
          commit('setParam', { name: 'metadata', val: response.data });
        } else if (
          state.panelMode == 'canditateStagePanel' ||
          (state.panelMode == 'coordinationPlan' && response)
        ) {
          commit('setParam', { name: 'metadata', val: response.data });
        } else if (
          state.panelMode == 'vacancyPanel' &&
          response &&
          response.status != 'error'
        ) {
          commit('setParam', { name: 'metadata', val: response.data });
        }
      } catch (e) {
        console.error(e);
        localStorage.setItem('rightPanelMode', null);
        commit('setParam', { name: 'panelMode', val: null });
      } finally {
        commit('setParam', { name: 'loading', val: false });
      }
    }
  }
};
